import { render } from "./DashboardDayTime.vue?vue&type=template&id=0b3a3922&ts=true"
import script from "./DashboardDayTime.vue?vue&type=script&lang=ts"
export * from "./DashboardDayTime.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__